import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ZoneOption } from "../../../domain/entities/pending-confirmation";
import { type PendingConfirmationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listGeoCatalog = createAsyncThunk<
  ZoneOption[],
  void,
  { dispatch: PendingConfirmationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_GEO_CATALOG, async (_, { extra }) => {
  return await extra.contactCenterRepo.listGeoCatalog();
});
